import { postAction } from './api.js';
import { sharingSpinner, shareIcon24, iconCheck2 } from './templates.js';

export function initEvents() {
    // Share action
    jQuery(document).on('click', 'a.timeline-share', function (e) {
        var loading_icon = sharingSpinner;
        var share_icon = shareIcon24;
        var ok_icon = iconCheck2;
        e.preventDefault();
        var _that = jQuery(this);
        var activity_id = _that.attr('href');

        // UI: close options and show loading
        _that.parents('.sharing-options').removeClass('open');
        _that.parents('.th-bp-post-share-button').find('a.activity-share .share_icon').html(loading_icon);

        postAction('tophive_bp_share_activity', { activity_id: activity_id })
            .then(function (response) {
                console.log(response);
                if (response) {
                    _that.parents('.th-bp-post-share-button').find('a.activity-share .share_icon').html(ok_icon);
                }
                setTimeout(function () {
                    _that.parents('.th-bp-post-share-button').find('a.activity-share .share_icon').html(share_icon);
                }, 2000);
            })
            .catch(function (err) {
                console.log(err);
            });
    });

    // Friends / accept action
    jQuery(document).on('click', '.bp-th-friends-button', function (e) {
        e.preventDefault();
        var user_id = jQuery(this).attr('data-user-id');
        var _that = jQuery(this);

        postAction('tophive_bp_friends_action', { user_id: user_id })
            .then(function (response) {
                if (_that.closest('.notifications-action-buttons').length) {
                    _that.closest('.notifications-action-buttons').fadeOut();
                } else if (response && response.result === true) {
                    _that.html(response.text);
                }
            })
            .catch(function (err) {
                console.log(err);
            });
    });

    // Follow / unfollow
    jQuery(document).on('click', '.bp-th-follow-button', function (e) {
        e.preventDefault();

        var following_id = jQuery(this).attr('data-following-id');
        var follower_id = jQuery(this).attr('data-follower-id');
        var status = jQuery(this).attr('data-following');
        var _that = jQuery(this);

        postAction('metafans_handle_follow', { following_id: following_id, follower_id: follower_id })
            .then(function (response) {
                _that.toggleClass('following');
                var isMini = _that.hasClass('follow-button-mini');
                if (status === 'following') {
                    _that.html(isMini ? Metafans_JS.follow_mini : Metafans_JS.follow);
                } else {
                    _that.html(isMini ? Metafans_JS.following_mini : Metafans_JS.following);
                }

                console.log(response);
                if (response && response.is_following) {
                    _that.attr('data-following', 'following');
                } else {
                    _that.attr('data-following', '');
                }

                jQuery('.followers-count-' + following_id).html(response.followers_count);
                jQuery('.following-count-' + follower_id).html(response.following_count);
            })
            .catch(function (err) {
                console.log(err);
            });
    });

    // Group join / leave
    jQuery(document).on('click', '.bp-group-join-btn, .bp-group-leave-btn', function (e) {
        e.preventDefault();

        const $btn = jQuery(this);
        const groupId = $btn.data('group-id');
        const isLeaving = $btn.hasClass('bp-group-leave-btn');

        postAction('mf_handle_group_join_leave', {
            group_id: groupId,
            do_leave: isLeaving ? 1 : 0,
            nonce: Metafans_JS.group_nonce,
        })
            .then(function (response) {
                console.log(response);
                if (response && response.success) {
                    if (response.data.joined) {
                        $btn.removeClass('bp-group-join-btn')
                            .addClass('bp-group-leave-btn')
                            .text(Metafans_JS.group_leave);
                    } else {
                        $btn.removeClass('bp-group-leave-btn')
                            .addClass('bp-group-join-btn')
                            .text(Metafans_JS.group_join);
                    }
                } else {
                    alert((response && response.data) || 'Something went wrong');
                }
            })
            .finally(function () {
                $btn.prop('disabled', false);
            })
            .catch(function () {
                alert('Error connecting to server.');
            });
    });
}

export default { initEvents };
